import { render } from "./index.vue?vue&type=template&id=0b123f04&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=0b123f04&lang=less&scoped=true"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b123f04"],['__file',"src/views/manga-info/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b123f04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b123f04', __exports__)) {
    console.log('reload')
    api.reload('0b123f04', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0b123f04&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0b123f04', render)
  })

}


export default __exports__